import type { ReactNode } from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'

// Match the modal safety used elsewhere in the repo so Select/Popover portals
// inside the technician drawer do not accidentally close it.
const pointerDownWithPopperOpen = new WeakSet<Event>()
if (typeof document !== 'undefined') {
  document.addEventListener(
    'pointerdown',
    event => {
      if (document.querySelector('[data-radix-popper-content-wrapper]')) {
        pointerDownWithPopperOpen.add(event)
      }
    },
    true
  )
}

interface TechnicianFormDrawerShellProps {
  open: boolean
  onClose: () => void
  children: ReactNode
}

export function TechnicianFormDrawerShell({
  open,
  onClose,
  children,
}: TechnicianFormDrawerShellProps) {
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={next => {
        if (!next) onClose()
      }}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className='fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0' />
        <DialogPrimitive.Content
          className='tf-right-drawer-fixed-long border-[#e7e9ef] duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right'
          aria-describedby={undefined}
          onInteractOutside={event => {
            const original = event.detail.originalEvent
            const eventTarget = original.target as Element | null
            if (
              pointerDownWithPopperOpen.has(original) ||
              eventTarget?.closest('[data-radix-popper-content-wrapper]')
            ) {
              event.preventDefault()
            }
          }}
        >
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}

export default TechnicianFormDrawerShell
